import React from "react";

import { getFirstUserFacingError } from "~/lib/utils";
import { useNavDispatchPanel } from "~/nav";
// eslint-disable-next-line max-len
import { ReactComponent as AskFellowIconActive } from "~/stream/SuggestedActions/ask-fellow-outline-small.svg";
import { toast } from "~/ui";

import { useAskFellowContextFromURL, useCreateConversationMutation } from "./AskFellowHooks";

import styles from "./AskFellowButton.module.css";

function AskFellowButton({ source = "ask_fellow_button" }: { source?: string }) {
	const context = useAskFellowContextFromURL();
	const dispatchPanel = useNavDispatchPanel();

	const [createConversation, mutationInProgress] = useCreateConversationMutation();
	const onCreateConversation = React.useCallback(async () => {
		if (mutationInProgress) return;

		try {
			await createConversation(context?.id, context?.filters);
			dispatchPanel("ask-fellow", true, { event: "[Ask Copilot] Modal opened", properties: { source }, options: {} });
		} catch (e) {
			const message = getFirstUserFacingError(e) ?? "Something went wrong; please try again later.";
			toast.error(message);
		}
	}, [context?.id, context?.filters, createConversation, mutationInProgress, dispatchPanel, source]);

	if (context) {
		return (
			<button className={styles.askFellowButton} onClick={onCreateConversation}>
				<AskFellowIconActive />
				<span>Ask Fellow</span>
			</button>
		);
	}

	return null;
}

export default AskFellowButton;
